import SparkMD5 from "spark-md5";

// 去掉文件扩展名
export function removeExtension(fileName: string) {
  // 找到最后一个 . 的位置
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) {
    // 如果没有找到 .，则返回原始文件名
    return fileName;
  } else {
    // 如果找到了 .，则返回去掉扩展名的部分
    return fileName.substring(0, lastDotIndex);
  }
}

// 计算文件的哈希值
export function calculateFileHash(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event: ProgressEvent<FileReader>) {
      const arrayBuffer = event.target!.result;

      crypto.subtle
        .digest("SHA-256", arrayBuffer as ArrayBuffer)
        .then(hashBuffer => {
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray
            .map(byte => byte.toString(16).padStart(2, "0"))
            .join("");
          resolve(hashHex);
        })
        .catch(error => reject(error));
    };

    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });
}

// 计算文件的md5
export function calculateFileMd5(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const chunkSize = 2097152; // 2MB chunks
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const reader = new FileReader();

    reader.onload = function (event: ProgressEvent<FileReader>) {
      if (event.target?.error) {
        reject(event.target.error);
        return;
      }
      if (event.target?.result) {
        spark.append(event.target.result as ArrayBuffer);
      }

      currentChunk++;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        resolve(spark.end());
      }
    };

    reader.onerror = function (error) {
      reject(error);
    };

    function loadNext() {
      const start = currentChunk * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      reader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNext();
  });
}
